import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import AddressFormCardStandard from "../../common/forms/AddressFormCardStandard";
import * as Library from "../../../utils/Library";
import { useDispatch, useSelector } from "react-redux";
import { setNavigations } from "../../../utils/redux/navigationAccessSlice";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import LayoutContext from "../../../LayoutContext";
import FormCard from "../../common/forms/FormCard";
import FormField from "../../common/forms/FormField";
import { getDropdownData } from "../../../utils/dropdownData";
import { ReactComponent as CalendarIcon } from "../../../assets/images/calender.svg";
import { ReactComponent as Glob } from "../../../assets/images/glob.svg";
import UrlIcon from "../../../assets/images/url-icon.svg";
import LinkedIn from "../../../assets/images/linkedin.svg";
import Twitter from "../../../assets/images/twitter.svg";
import Facebook from "../../../assets/images/facebook.svg";
import Instagram from "../../../assets/images/instagram.svg";
import SimpleButtonContentHeader from "./../../common/mainApp/mainWindowHeaders/SimpleButtonContentHeader";
import UploadLogosCardStandard from "../../common/forms/UploadLogosCardStandard";
import AppContext from "../../../AppContext";
import { userIsOnBoardingInPage } from "../../../utils/onboardingHelper";
import { formatPhoneNumber } from "../../../utils/Formatter";

// #region SCOPED CSS
const StyledPage = styled.div``;

const CardTitleButtonStyled = styled.div`
    &.btn-sm-inverted-card-header,
    &.btn-sm-inverted-card-header * {
        box-sizing: border-box;
    }
    &.btn-sm-inverted-card-header {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        padding: 7px 10px 8px 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 16px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 8px;
        letter-spacing: 0.0125em;
        font-weight: 400;
        text-transform: uppercase;
        position: relative;
    }
`;
// #endregion

export default function CreateCompanyPage() {
    const location = useLocation();
    const isCreatePage = location.pathname.includes("/create" || "/new" || "/add");
    document.title = `${APP_TITLE} - Companies ${isCreatePage ? "Create" : "Edit"}`;

    // #region STATES
    const navigations = useSelector(state => state.navigationAccesses);
    const { MainLayoutProps, layoutType } = useOutletContext();

    const {
        showIsAccountSavedPopup,
        setShowIsAccountSavedPopup,
        setShowIsCompanySavedPopup,
        readyToSavePopup,
        setReadyToSavePopup
    } = React.useContext(LayoutContext);
    const { setHasUnsavedChanges } = React.useContext(AppContext);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { companyID } = useParams();

    const formCompanyID = useRef();
    const formCompanySocialMedia = useRef();
    const formAccountLogosRef = useRef();
    const formCompanyAddress = useRef();

    const formCompanyFieldsRefs = [];
    const formCompanySocialMediaFieldsRefs = [];

    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData,
        navigations: navigations
    };

    const [isLoading, setIsLoading] = useState(false);
    const [hasFetchedCompanyFirstTime, setHasFetchedCompanyFirstTime] = useState(false);
    const [hasCheckedPhoneNumber, setHasCheckedPhoneNumber] = useState(false);
    const [isFetchingData, setIsFetchingData] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false);

    const [countryOptions] = useState(getDropdownData("countryOptions"));

    //COMPANY ID FIELDS
    const [companyName, setCompanyName] = useState("");
    const [companyIDCountry, setCompanyIDCountry] = useState("");
    const [selectedPhoneCountryCode, setSelectedPhoneCountryCode] = useState("");
    const [registrationNumber, setRegistrationNumber] = useState("");
    const [companyRegistrationDate, setCompanyRegistrationDate] = useState("");
    const [selectedTaxCode, setSelectedTaxCode] = useState("");
    const [taxNumber, setTaxNumber] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [doingBusinessAs, setDoingBusinessAs] = useState("");
    const [businessWebsite, setBusinessWebsite] = useState("");
    const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("");
    const [businessEmail, setBusinessEmail] = useState("");
    const [businessType, setBusinessType] = useState("Retail");

    const [companyAddressFormValues, setCompanyDetails] = useState({
        initialized: false,
        legalBusinessName: "",
        googlePlusCode: "",
        companyCountry: "",
        companyAddressCountry: "",
        companyCity: "",
        companyPostalCode: "",
        companyAddressOne: "",
        companyAddressTwo: "",
        companyLatitude: "",
        companyLongitude: ""
    });

    const [logoFieldsState, setLogoFieldsState] = useState(null);

    const [companySocialMedia, setCompanySocialMedia] = useState({
        companyWebsite: "",
        companyLinkedIn: "",
        companyX: "",
        companyFacebook: "",
        companyInstagram: ""
    });
    // #endregion

    // #region METHODS
    const selectTimezoneAndPhoneNumber = data => {
        const selectedCountryID = data?.id;
        const phoneCountryCodes = getDropdownData("countryCodeOptions");
        const taxIdData = getDropdownData("taxNumberOptions");
        const selectedPhoneCountryCodeTMP = phoneCountryCodes.find(country => country.id === selectedCountryID);
        const selectedTaxCode = taxIdData?.find(country => country.value === selectedCountryID);
        setSelectedPhoneCountryCode(selectedPhoneCountryCodeTMP?.value);
        setSelectedTaxCode(selectedTaxCode?.value ?? "");
        setTaxNumber(selectedTaxCode?.value === "NO" ? registrationNumber : "");
    };

    //TODO:====================| Temporary |=========================
    useEffect(() => {
        const countryValue = localStorage.getItem("currentOrganizationCountry");
        const currentCountryObj = countryOptions.find(country => country.value === countryValue);
        selectTimezoneAndPhoneNumber(currentCountryObj);
        setCompanyIDCountry(currentCountryObj?.value);
    }, [countryOptions]);
    //===============================================================

    // if false -> don't highlight invalid fields
    const checkFormIsValid = (highlightValidation = false) => {
        if (
            !formCompanyID.current ||
            !formCompanyAddress.current ||
            !formAccountLogosRef.current ||
            !formCompanySocialMedia.current
        ) {
            return;
        }
        const allCompanyIdFieldsAreValid = formCompanyID.current.allFieldsAreValid(highlightValidation);
        const allAddressFieldsAreValid = formCompanyAddress.current.allFieldsAreValid(highlightValidation);
        const allLogosAreValid = formAccountLogosRef.current.allFieldsAreValid(highlightValidation);
        const allSocialFieldsAreValid = formCompanySocialMedia.current.allFieldsAreValid(highlightValidation);

        const allFieldsAreValid =
            allCompanyIdFieldsAreValid && allLogosAreValid && allAddressFieldsAreValid && allSocialFieldsAreValid;

        setSaveButtonEnabled(allFieldsAreValid);

        return allFieldsAreValid;
    };

    const onSaveClicked = async () => {
        const companyIDFormValues = formCompanyID.current.getAllFieldValues();
        const socialMediaFormValues = formCompanySocialMedia.current.getAllFieldValues();
        const logoFieldValues = formAccountLogosRef.current.getAllFieldValues();
        const companyAddressFormValues = formCompanyAddress.current.getAllFieldValues();

        const { companyFacebook, companyInstagram, companyLinkedIn, companyWebsite, companyX } = socialMediaFormValues;

        const {
            legalBusinessName,
            country,
            registrationNumber,
            date,
            taxNumber,
            businessPhoneNr,
            doingBusinessAs,
            privacyPolicyUrl,
            businessEmail,
            businessWebsite
        } = companyIDFormValues;

        let phoneNrNoCountryCodeNr = businessPhoneNr?.replace(/\s/g, "");
        phoneNrNoCountryCodeNr = phoneNrNoCountryCodeNr?.substring(selectedPhoneCountryCode?.length + 1);

        const googlePlusCode = companyAddressFormValues?.googlePlusCode || "";
        const companyAddressCountry = companyAddressFormValues?.country?.value || "";
        const companyCity = companyAddressFormValues?.city?.value || "";
        const companyPostalCode = companyAddressFormValues?.postalCode || "";
        const companyAddressOne = companyAddressFormValues?.addressOne || "";
        const companyAddressTwo = companyAddressFormValues?.addressTwo || "";
        const companyLatitude = companyAddressFormValues?.latitude || "";
        const companyLongitude = companyAddressFormValues?.longitude || "";

        const jsonPostData = {
            companyID: localStorage.getItem("currentCompanyID"),
            name: legalBusinessName || "",
            countryValue: country?.value || "",
            registrationNumber: registrationNumber.replace(/\s/g, "") || "",
            registrationDate: date || "",
            taxPreLabel: selectedTaxCode || "",
            taxNumber: taxNumber.replace(/\s/g, "") || "",
            taxPosLabel: selectedTaxCode === "NO" ? "MVA" : "",
            phoneNumberCountryCode: selectedPhoneCountryCode || "",
            phoneNumber: phoneNrNoCountryCodeNr || "",
            businessName: doingBusinessAs || "",
            businessEmail: businessEmail || "",
            businessWebsite: businessWebsite || "",
            businessType: "Retail",
            mainLogoData: logoFieldValues.mainLogoData,
            compactLogoData: logoFieldValues.compactLogoData,
            location: {
                latitude: companyLatitude || "",
                longitude: companyLongitude || "",
                googlePlusCode: googlePlusCode || "",
                countryValue: companyAddressCountry || "",
                city: companyCity || "",
                postalCode: companyPostalCode || "",
                addressLine1: companyAddressOne || "",
                addressLine2: companyAddressTwo || "",
                addressNumber: ""
            },
            socialMedia: {
                website: companyWebsite || "",
                privacyPolicy: privacyPolicyUrl || "",
                linkedin: companyLinkedIn || "",
                X: companyX || "",
                facebook: companyFacebook || "",
                instagram: companyInstagram || ""
            }
        };

        setHasUnsavedChanges(false);

        Library.makeCommonPostRequest("Company", "updateCompany", jsonPostData, false, setIsLoading).then(res => {
            if (res?.data?.status === 200) {
                if (userIsOnBoardingInPage(navigations, "companies")) {
                    const updatedNavigations = {
                        ...navigations.navigationAccesses,
                        companies: {
                            ...navigations.navigationAccesses.companies,
                            createModeOnly: false
                        },
                        retailBrands: {
                            ...navigations.navigationAccesses.retailBrands,
                            createModeOnly: true,
                            navigationPanel: true
                        }
                    };
                    dispatch(setNavigations({ navigationAccesses: updatedNavigations }));
                    localStorage.removeItem("tempCountryValue");
                    navigate("/brands/create");
                    setShowIsCompanySavedPopup(true);
                    localStorage.setItem("activeCompanies", 1);
                } else {
                    localStorage.removeItem("tempCountryValue");
                    navigate("/companies");
                    Library.showToastMessage({
                        type: "success",
                        title: isCreatePage ? "Company has been created!" : "Company data has been updated!"
                    });
                }

                localStorage.setItem("currentCompanyName", legalBusinessName);
            } else setHasUnsavedChanges(true);
        });
    };

    const generateLogoFields = (largeLogoImageData, smallLogoImageData) => {
        const logosState = [
            {
                label: "Main logo",
                varName: "mainLogoData",
                requiredType: "mandatory",
                tooltip:
                    "Upload or enter the main logo used to represent your company across platforms. This should be the full version of your brand logo, typically used on websites, documents, and marketing materials.",
                imageData: largeLogoImageData,
                gridColumnSize: 2
            },
            {
                label: "Compact logo",
                varName: "compactLogoData",
                requiredType: "recommended",
                tooltip:
                    "Upload or enter a simplified or icon version of your company logo. This is often used in smaller spaces like app icons, favicons, or profile thumbnails.",
                imageData: smallLogoImageData,
                gridColumnSize: 1
            }
        ];

        setLogoFieldsState(logosState);

        setTimeout(() => {
            checkFormIsValid(false);
        }, 100);
    };

    const getAccountData = async () => {
        const formData = {
            // id: localStorage.getItem("token")
        };
        const res = await Library.makeCommonPostRequest(
            "Organization",
            "getOrganizationData",
            formData,
            false,
            setIsFetchingData
        );

        if (res?.data?.status !== 200) return;
        const data = res?.data?.data;
        return data;
    };

    const logosSameAsAccount = async () => {
        const data = await getAccountData();
        if (!data) return;

        const { mainImageUrl, squareImageUrl } = data?.OrganizationInfo;

        generateLogoFields(
            mainImageUrl ? { url: mainImageUrl, name: "mainLogo" } : null,
            squareImageUrl ? { url: squareImageUrl, name: "compactLogo" } : null
        );
    };

    const getCompanyData = async companyID => {
        const res = await Library.makeCommonPostRequest(
            "Company",
            "getCompany",
            { companyID: companyID },
            false,
            setIsLoading
        );

        if (res?.data?.status !== 200) return;
        const data = res?.data?.data;

        const {
            name,
            countryValue,
            registrationNumber,
            registrationDate,
            taxPreLabel,
            taxNumber,
            phoneNumberCountryCode,
            phoneNumber,
            businessName,
            businessEmail,
            businessType,
            businessWebsite,
            location,
            socialMedia,
            mainLogoURL,
            compactLogoURL
        } = data;

        const {
            googlePlusCode,
            countryValue: companyAddressCountry,
            city,
            postalCode,
            addressLine1,
            addressLine2,
            latitude,
            longitude
        } = location;

        const { website, privacyPolicy, linkedin, X, facebook, instagram } = socialMedia;

        const formattedRegNumber = formatTaxAndRegNumber(registrationNumber);
        const formattedTaxNumber = formatTaxAndRegNumber(taxNumber);

        //if phone nr has space, remove country code separated by space
        const formattedPhoneNumber = phoneNumber.includes(" ") ? phoneNumber.split(" ")[1] : phoneNumber;

        setCompanyName(name);
        setCompanyIDCountry(countryValue);
        setRegistrationNumber(formattedRegNumber);
        setCompanyRegistrationDate(registrationDate);
        setTaxNumber(formattedTaxNumber);
        setPhoneNumber(formattedPhoneNumber);
        setSelectedPhoneCountryCode(phoneNumberCountryCode);
        setSelectedTaxCode(taxPreLabel);
        setDoingBusinessAs(businessName);
        setBusinessWebsite(businessWebsite);
        setPrivacyPolicyUrl(privacyPolicy);
        setBusinessEmail(businessEmail);
        setBusinessType(businessType);

        setCompanyDetails({
            initialized: true,
            legalBusinessName: name,
            googlePlusCode,
            companyCountry: countryValue,
            companyAddressCountry,
            companyCity: city,
            companyPostalCode: postalCode,
            companyAddressOne: addressLine1,
            companyAddressTwo: addressLine2,
            companyLatitude: latitude,
            companyLongitude: longitude
        });

        const mainLogoData = mainLogoURL ? { url: mainLogoURL, name: "mainLogo" } : null;
        const compactLogoData = compactLogoURL ? { url: compactLogoURL, name: "compactLogo" } : null;

        generateLogoFields(mainLogoData, compactLogoData);

        setCompanySocialMedia({
            companyWebsite: website,
            companyLinkedIn: linkedin,
            companyX: X,
            companyFacebook: facebook,
            companyInstagram: instagram
        });

        setHasFetchedCompanyFirstTime(true);
    };

    const formatTaxAndRegNumber = (text, digitsCount = 3) => {
        //reg number and tax number should be "### ### ###" with spaces every 3 digits
        if (!text) return "";

        const formattedValue = text
            ?.toString()
            ?.replace(/\D/g, "")
            ?.replace(new RegExp(`(\\d{${digitsCount}})(?=\\d)`, "g"), "$1 ");
        return formattedValue;
    };
    // #endregion METHODS

    // #region FORM FIELDS
    const formCompanyFields = [
        <FormField
            type="text"
            title="Legal Business name"
            tooltip="Your company’s full, official name as registered with the relevant government or legal authority. This should match the name on your business registration documents, tax filings, or other formal records."
            requiredType="mandatory"
            assistiveText="KYC"
            varName="legalBusinessName"
            ref={el => (formCompanyFieldsRefs.legalBusinessName = el)}
            onTextChange={e => {
                setCompanyName(e);
            }}
            value={companyName}
        />,
        <FormField
            type="dropdown"
            dropdownData={countryOptions}
            title="Country"
            assistiveText="KYC"
            isDropdownSearchable={true}
            tooltip="Select the country where your business is legally registered and operates. This should match the country listed in your official registration or incorporation documents."
            requiredType="mandatoryLocked"
            varName="country"
            onDropdownChange={selectTimezoneAndPhoneNumber}
            value={companyIDCountry}
            ref={el => (formCompanyFieldsRefs.country = el)}
        />,
        <FormField
            type="registrationNumber"
            title="Registration number"
            tooltip="Enter the unique number assigned to your business by the official company registry in your country. This number is used to identify your company for legal, tax, and administrative purposes."
            requiredType="mandatory"
            assistiveText="KYC"
            varName="registrationNumber"
            ref={el => (formCompanyFieldsRefs.registrationNumber = el)}
            onTextChange={e => {
                const value = e.replace(/\s/g, "");
                let formattedValue = formatTaxAndRegNumber(value, selectedTaxCode === "DK" ? 2 : 3);

                if (selectedTaxCode === "NO") setTaxNumber(formattedValue);
                // if DK, no spaces in tax number
                if (selectedTaxCode === "DK") formattedValue = value;
                setRegistrationNumber(formattedValue);
            }}
            value={e => {
                // if DK, no spaces in registration number
                return selectedTaxCode === "DK"
                    ? registrationNumber.replace(/\s/g, "")
                    : formatTaxAndRegNumber(registrationNumber, selectedTaxCode === "DK" ? 2 : 3);
            }}
            extraFields={{ countryCode: selectedTaxCode }}
        />,
        <FormField
            type="date"
            title="Registration Date"
            tooltip="Enter the official date your company was legally registered or incorporated with the relevant government authority. This is typically the date listed on your company’s registration certificate or incorporation documents."
            requiredType="mandatory"
            leftContent={<CalendarIcon className="flex" />}
            varName="date"
            ref={el => (formCompanyFieldsRefs.date = el)}
            datePickerPlaceholder={" "}
            value={companyRegistrationDate}
        />,
        <FormField
            type="taxNumber"
            title="Tax Number"
            tooltip="Enter your company’s official tax identification number issued by your country’s tax authority. This number is used for tax reporting and compliance purposes."
            rightContent={selectedTaxCode === "NO" ? "MVA" : ""}
            taxNumberCountryCode={selectedTaxCode}
            varName="taxNumber"
            requiredType="mandatory"
            assistiveText="KYC"
            value={formatTaxAndRegNumber(taxNumber, selectedTaxCode === "DK" ? 2 : 3)}
            ref={el => (formCompanyFieldsRefs.taxNumber = el)}
        />,
        <FormField
            type="phoneNumber"
            title="Business phone nr"
            tooltip="Enter your company’s main contact number, including the country code. This should be a number where your business can be reached during working hours."
            requiredType="mandatory"
            varName="businessPhoneNr"
            assistiveText="KYC"
            ref={el => (formCompanyFieldsRefs.businessPhoneNr = el)}
            phoneNumberCountryCode={selectedPhoneCountryCode}
            onCountryCodeChange={e => {
                setSelectedPhoneCountryCode(e.value);
            }}
            value={formatPhoneNumber(selectedPhoneCountryCode, phoneNumber)}
            onTextChange={setPhoneNumber}
        />,
        <FormField
            type="text"
            title="Doing business as"
            tooltip="If your company operates under a name that is different from its legal business name, please enter that name here. This is the trade name or brand name your business is publicly known by."
            requiredType="mandatory"
            assistiveText="KYC"
            varName="doingBusinessAs"
            ref={el => (formCompanyFieldsRefs.doingBusinessAs = el)}
            value={doingBusinessAs}
        />,
        <FormField
            type="text"
            title="Business website"
            tooltip="Enter your company’s official corporate website. If your business does not have a corporate site, please provide the main website used to represent your business online."
            requiredType="mandatory"
            assistiveText="KYC"
            varName="businessWebsite"
            placeholder="https://"
            leftContent={<Glob className="flex" />}
            ref={el => (formCompanyFieldsRefs.businessWebsite = el)}
            value={businessWebsite}
        />,
        <FormField
            type="text"
            title="Privacy policy URL"
            tooltip="Enter the direct link to your company’s privacy policy page. This should be a publicly accessible webpage that explains how your business collects, uses, stores, and protects personal data."
            requiredType="mandatory"
            assistiveText="KYC"
            varName="privacyPolicyUrl"
            leftContent={<Glob className="flex" />}
            placeholder="https://"
            ref={el => (formCompanyFieldsRefs.privacyPolicyUrl = el)}
            value={privacyPolicyUrl}
        />,
        <FormField
            type="email"
            title="Business email"
            tooltip="Enter your company’s official email address used for business communications. This should be a monitored inbox where your organization can receive important messages related to registration, compliance, and customer inquiries."
            requiredType="mandatory"
            assistiveText="KYC"
            varName="businessEmail"
            leftContent={<img src={UrlIcon} alt="glob-icon" />}
            ref={el => (formCompanyFieldsRefs.businessEmail = el)}
            value={businessEmail}
        />,
        <FormField
            type="dropdown"
            title="Business type"
            dropdownData={[{ name: "Retail", value: "Retail" }]}
            isDropdownMultiselect={false}
            isDropdownSearchable={false}
            tooltip="Select the industry or category that best describes your company’s primary business activity. This helps us understand the nature of your operations for compliance and reporting purposes."
            requiredType="locked"
            assistiveText="KYC"
            varName="businessType"
            ref={el => (formCompanyFieldsRefs.businessType = el)}
            value={businessType}
        />
    ];

    const formCompanySocialMediaFields = [
        <FormField
            type="text"
            title="Company website"
            tooltip="Enter your company’s official website URL. This should be the main site used to represent your business online."
            requiredType="simple"
            varName="companyWebsite"
            leftContent={<Glob className="flex" />}
            placeholder="https://"
            value={companySocialMedia.companyWebsite}
            ref={el => (formCompanySocialMediaFieldsRefs.companyWebsite = el)}
            assistiveText=" "
        />,
        <FormField
            type="text"
            title="Company LinkedIn"
            tooltip="Enter the URL to your company’s LinkedIn page. This helps verify your business identity and connect professionally."
            requiredType="simple"
            varName="companyLinkedIn"
            placeholder="https://www.linkedin.com/in/"
            leftContent={<img src={LinkedIn} alt="LinkedIn" />}
            value={companySocialMedia.companyLinkedIn}
            ref={el => (formCompanySocialMediaFieldsRefs.companyLinkedIn = el)}
        />,
        <FormField
            type="text"
            title="Company X"
            tooltip="Enter your company’s handle or URL on X (formerly Twitter). This is used for public updates, engagement, and brand presence."
            requiredType="simple"
            varName="companyX"
            leftContent={<img src={Twitter} alt="X" />}
            placeholder="https://www.x.com/"
            value={companySocialMedia.companyX}
            ref={el => (formCompanySocialMediaFieldsRefs.companyX = el)}
            assistiveText=" "
        />,
        <FormField
            type="text"
            title="Company Facebook"
            tooltip="Enter the URL to your company’s Facebook page. This is used for community engagement, updates, and customer interaction."
            requiredType="simple"
            varName="companyFacebook"
            placeholder="https://www.facebook.com/"
            leftContent={<img src={Facebook} alt="calender-icon" />}
            value={companySocialMedia.companyFacebook}
            ref={el => (formCompanySocialMediaFieldsRefs.companyFacebook = el)}
            assistiveText=" "
        />,
        <FormField
            type="text"
            title="Company Instagram"
            tooltip="Enter the URL or handle for your company’s Instagram profile. This is typically used for visual branding and customer engagement."
            requiredType="simple"
            varName="companyInstagram"
            placeholder="https://www.instagram.com/"
            leftContent={<img src={Instagram} alt="Instagram" />}
            value={companySocialMedia.companyInstagram}
            ref={el => (formCompanySocialMediaFieldsRefs.companyInstagram = el)}
            assistiveText=" "
        />
    ];
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        const userIsOnboarding = userIsOnBoardingInPage(navigations, "companies");

        setupHeaders(props, saveButtonEnabled, setReadyToSavePopup, navigations, isCreatePage, userIsOnboarding);
    }, [props?.layoutType, navigations, saveButtonEnabled, isCreatePage]); // setup headers

    useEffect(() => {
        generateLogoFields(null, null);
    }, []); // generate logo fields

    useEffect(() => {
        if (!navigations?.navigationAccesses) return;

        if (isCreatePage && !navigations.navigationAccesses.companies.createModeOnly) {
            //if user is not onboarding on company, redirecting to home page
            if (!Library.isLocalhost("Update Company Data")) {
                navigate("/");
            }
            return;
        }
    }, [navigations]); // check if user has access to create company page

    useEffect(() => {
        if (!companyAddressFormValues || !localStorage.getItem("tempCountryValue") || !!selectedTaxCode) return;

        const countryValue = localStorage.getItem("tempCountryValue");
        const registrationNumberValue = localStorage.getItem("tempRegistrationNumber");
        const phoneNumberValue = localStorage.getItem("tempPhoneNumber");
        const companyNameValue = localStorage.getItem("currentCompanyName");
        const businessPhoneNr = phoneNumberValue.split(" ")[1];
        setCompanyIDCountry(countryValue);
        const countrySelectedID = countryOptions.find(country => country.value === countryValue)?.id;
        selectTimezoneAndPhoneNumber({ id: countrySelectedID, name: countryValue });
        setRegistrationNumber(registrationNumberValue?.replace(/\s/g, "") || "");
        setPhoneNumber(businessPhoneNr);
        setCompanyName(companyNameValue);
        setDoingBusinessAs(companyNameValue);
        setTaxNumber(
            countrySelectedID === "NO"
                ? registrationNumberValue?.replace(/\s/g, "")
                : countrySelectedID === "DK"
                  ? registrationNumberValue?.replace(/\s/g, "")
                  : ""
        );
    }, [companyAddressFormValues]); // set company form values

    useEffect(() => {
        if (!companyID) return;

        getCompanyData(companyID);
    }, [companyID]); // get company data

    useEffect(() => {
        if (!hasFetchedCompanyFirstTime || hasCheckedPhoneNumber) return;

        setTimeout(() => {
            if (!formCompanyFieldsRefs.businessPhoneNr) return;

            formCompanyFieldsRefs.businessPhoneNr.isValid(true);
            setHasCheckedPhoneNumber(true);
        }, 100);
    }, [formCompanyFieldsRefs, hasFetchedCompanyFirstTime, hasCheckedPhoneNumber]); //check if businessPhoneNr is valid after loading company data only 1 time
    // #endregion

    // #region RENDER
    return (
        <StyledPage>
            <div>
                <FullScreenOverlay show={showIsAccountSavedPopup}>
                    <DialogBoxComponent
                        onClickYes={() => setShowIsAccountSavedPopup(false)}
                        title="Account is now saved!"
                        heading="Success!"
                        headingColor="#00BB00"
                        message={
                            "<div style='font-size: 14px; margin: 0 -5px;'>You can now proceed with enrolling your Company</div>"
                        }
                        // useImageHeader={{ src: BOStageBLogo, width: "165px" }}
                        showConfirm={() => setShowIsAccountSavedPopup(false)}
                        showCancel={false}
                        confirmText="CONTINUE"
                    />
                </FullScreenOverlay>

                <FullScreenOverlay show={readyToSavePopup}>
                    <DialogBoxComponent
                        headingColor="var(--text-icons-blue-500)"
                        title="Ready to save?"
                        message="You can still change it later. No worries:)"
                        onClickYes={() => {
                            setReadyToSavePopup(false);
                            onSaveClicked();
                        }}
                        loading={isLoading}
                        loadingHeading={"SUBSCRIBING.."}
                        onClickNo={() => {
                            setReadyToSavePopup(false);
                        }}
                        cancelText="No"
                        confirmText="Yes"
                    />
                </FullScreenOverlay>

                <FullScreenOverlay show={isLoading}>
                    <DialogBoxComponent
                        headingColor="var(--text-icons-green-500)"
                        heading="SAVING..."
                        showCancel={false}
                        showConfirm={false}
                        loading={isLoading}
                    />
                </FullScreenOverlay>

                <FormCard
                    title="COMPANY ID"
                    ref={formCompanyID}
                    numOfFieldsPerLine={4}
                    showDefaultRightLegends={true}
                    formFields={formCompanyFields}
                    formFieldRefs={formCompanyFieldsRefs}
                    onFormChanged={checkFormIsValid}
                    showUnsavedChangesPopup={true}
                />

                <AddressFormCardStandard
                    cardTitle="COMPANY ADDRESS"
                    ref={formCompanyAddress}
                    pinLabel={companyName}
                    unnamedPinLabel={"Unnamed Company"}
                    useGoogleMapsDarkMode={true}
                    hasKYCAssistiveText={true}
                    onFormChanged={checkFormIsValid}
                    locationDetails={{
                        initialized: companyAddressFormValues.initialized,
                        googlePlusCode: companyAddressFormValues.googlePlusCode,
                        country: companyAddressFormValues.companyAddressCountry,
                        city: companyAddressFormValues.companyCity,
                        postalCode: companyAddressFormValues.companyPostalCode,
                        addressOne: companyAddressFormValues.companyAddressOne,
                        addressTwo: companyAddressFormValues.companyAddressTwo,
                        latitude: companyAddressFormValues.companyLatitude,
                        longitude: companyAddressFormValues.companyLongitude
                    }}
                    onLocationDetailsChange={locationDetails => {
                        const {
                            googlePlusCode,
                            country,
                            city,
                            postalCode,
                            addressOne,
                            addressTwo,
                            latitude,
                            longitude
                        } = locationDetails;

                        setCompanyDetails({
                            ...companyAddressFormValues,
                            googlePlusCode,
                            companyAddressCountry: country,
                            companyCity: city,
                            companyPostalCode: postalCode,
                            companyAddressOne: addressOne,
                            companyAddressTwo: addressTwo,
                            companyLatitude: latitude,
                            companyLongitude: longitude
                        });
                    }}
                />

                <UploadLogosCardStandard
                    cardTitle="COMPANY LOGO"
                    key="companyLogos"
                    ref={formAccountLogosRef}
                    logoFields={logoFieldsState}
                    onLogoFieldsChanged={() => checkFormIsValid(false)}
                    afterTitleComponent={
                        <CardTitleButton
                            title="SAME AS ACCOUNT"
                            onClick={logosSameAsAccount}
                            isFetchingData={isFetchingData}
                        />
                    }
                />

                <FormCard
                    title="COMPANY SOCIAL MEDIA"
                    ref={formCompanySocialMedia}
                    numOfFieldsPerLine={4}
                    showDefaultRightLegends={true}
                    formFields={formCompanySocialMediaFields}
                    formFieldRefs={formCompanySocialMediaFieldsRefs}
                    onFormChanged={checkFormIsValid}
                    showUnsavedChangesPopup={true}
                />
            </div>
        </StyledPage>
    );
    // #endregion
}

// #region FUNCTIONS
function setupHeaders(props, saveButtonEnabled, setReadyToSavePopup, navigations, isCreatePage, userIsOnboarding) {
    const createMode = userIsOnBoardingInPage(navigations, "companies");

    props.setControlBarLeftBtns([{ to: "#", disabled: true, title: "Company", icon: "fa-magnifying-glass" }]);
    props.setControlBarCenterBtns([
        { to: "/companies/create", active: true, disabled: false, title: "Companies" },
        { to: "#", active: false, disabled: true, title: "KYC POLICY" }
    ]);

    if (isCreatePage || userIsOnboarding) {
        props.setControlBarRightBtns([
            { to: "/companies", active: false, disabled: createMode, title: "View", icon: "eye" },
            { to: "/companies/create", active: true, disabled: false, title: "Add", icon: "plus" },
            { to: "#", active: false, disabled: true, title: "Details", icon: "microscope" }
        ]);
    } else {
        props.setControlBarRightBtns([
            { to: "/companies", active: false, disabled: false, title: "Back", icon: "chevron-left" },
            { to: "#", active: true, disabled: false, title: "Edit", icon: "pencil-line" }
        ]);
    }

    props.setFilterHeaderProperties({
        customContentHeader: (
            <SimpleButtonContentHeader
                btnTitle="SAVE"
                btnEnabled={saveButtonEnabled}
                onClick={() => {
                    setReadyToSavePopup(true);
                }}
            />
        )
    });
}
// #endregion

export const CardTitleButton = ({ title, onClick, isFetchingData = false }) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "8px"
            }}>
            <CardTitleButtonStyled className="btn-sm-inverted-card-header" onClick={onClick}>
                <div className="button">{title}</div>
            </CardTitleButtonStyled>
            {isFetchingData && <i className="fa fa-spinner fa-spin" style={{ color: "var(--text-icons-green-500)" }} />}
        </div>
    );
};
